import UserProfileSelectionPopup from 'components/UserProfileSelectionPopup/UserProfileSelectionPopup';

export default UserProfileSelectionPopup;
